import {useEffect} from 'react';
import {setFeatureFlags} from '@chekin/core';
import {LAYOUT_MODE_KEY} from 'utils/constants';
import {useKioskoStore} from '../useKioskoStore';

export const useToggleKioskoMode = () => {
  const isConnected = useKioskoStore(state => state.connection.isConnected);
  const hasCompletedInitialization = useKioskoStore(
    state => state.connection.hasCompletedInitialization,
  );

  useEffect(() => {
    const storedLayout = localStorage.getItem(LAYOUT_MODE_KEY);

    if (storedLayout === 'kiosko') {
      setFeatureFlags({IT_4334_KIOSKO_MVP: true});
      return;
    }

    const url = new URL(window.location.href);
    const layoutParam = url.searchParams.get('layout');
    if (layoutParam === 'kiosko') {
      setFeatureFlags({IT_4334_KIOSKO_MVP: true});
      url.searchParams.delete('layout');
      window.history.replaceState({}, '', url.toString());
    }
  }, []);

  useEffect(() => {
    if (isConnected && hasCompletedInitialization) {
      const storedLayout = localStorage.getItem(LAYOUT_MODE_KEY);

      if (!storedLayout) {
        localStorage.setItem(LAYOUT_MODE_KEY, 'kiosko');
      }
    }
  }, [isConnected, hasCompletedInitialization]);
};
